import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required('Name is required'),
  countryId: yup.string(),
  address: yup.string().label('Address').min(2, 'Address should be at least 2 symbols'),
  uniqueCompanyNumber: yup.string().label('Unique Company Number').min(2, 'Unique Company Number should be at least 2 symbols').required('Unique Company Number is required'),
});

export default schema;
